const translation = {
    "orderNumber": "מספר הזמנה",
    "date": "תאריך",
    "createdBy": "נוצר ע\"י",
    "allOrdersTitle": "היסטוריית כל ההזמנות",
    "createdSuccessfully": "נוצר בהצלחה",
    "approvedBy": "אושר ע\"י",
    "rejectedBy": "סורב ע\"י",
    "waitingForApproval": "ממתין לאישור",
    "orderDetails": "פרטי הזמנה",
    "orderDate": "תאריך הזמנה",
    "confirmingEmail": "מאשר דוא\"ל",
    "rejectingEmail": "דוחה דוא\"ל",
    "createdAt": "נוצר בתאריך",
    "approved": "אושר",
    "rejected": "סורב",
    "pendingApproval": "בהמתנה לאישור"
  };

  export default translation;
  